import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * The credits / ownership / community-project text shared by the Licences and Rights footer dialog and the About
 * page. Rendered as a plain block so either host decides how to scroll and frame it.
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [],
    selector: 'app-licences-rights-content',
    template: `
        <div class="flex flex-col gap-4">
            <p>
                Powered by
                <a
                    class="font-medium underline underline-offset-4"
                    href="https://40kdc.alpacasoft.dev"
                    target="_blank"
                    rel="noopener noreferrer">
                    40kdc-data </a
                >.
            </p>

            <div class="rounded-md border border-border p-3">
                <p class="font-medium">Unit datasheets - Creative Commons Attribution 4.0 International</p>
                <p class="mt-2">
                    Datasheet stat lines, weapon profiles, points and structured ability definitions come from the
                    40kdc dataset, &copy; 2026 Alpaca Software and the 40kdc community contributors, used under
                    <a
                        class="font-medium underline underline-offset-4"
                        href="https://creativecommons.org/licenses/by/4.0/legalcode"
                        target="_blank"
                        rel="noopener noreferrer">
                        CC BY 4.0 </a
                    >.
                </p>
                <p class="mt-2">
                    You are free to share and adapt that material for any purpose, even commercially, provided you
                    give appropriate credit, link to the licence, and indicate if changes were made. You may not
                    apply legal terms or technological measures that legally restrict others from doing anything
                    the licence permits.
                </p>
                <p class="mt-2">
                    <span class="font-medium">Changes made:</span> datasheets shown here are derived from that
                    dataset rather than reproduced verbatim - units are filtered to those each Horde faction can
                    field, stat lines and weapon profiles are reformatted for display, and ability text is rendered
                    from the structured definitions.
                </p>
            </div>

            <p>
                The Horde game mode was created by and is owned by
                <a
                    class="font-medium underline underline-offset-4"
                    href="https://poorhammer.libsyn.com/"
                    target="_blank"
                    rel="noopener noreferrer">
                    The Poorhammer Podcast </a
                >. All of their Horde resources can be found on
                <a
                    class="font-medium underline underline-offset-4"
                    href="https://drive.google.com/drive/u/1/folders/1r0-H8Po8rkLjP1jsWT7ja4cdCwgQDWm5"
                    target="_blank"
                    rel="noopener noreferrer">
                    Google Drive </a
                >.
            </p>

            <p>
                Warhammer, Warhammer 40,000, Games Workshop, and all associated names, logos, characters,
                illustrations, images, and other intellectual property are trademarks and/or copyrights of
                <a
                    class="font-medium underline underline-offset-4"
                    href="https://www.warhammer.com/"
                    target="_blank"
                    rel="noopener noreferrer">
                    Games Workshop Limited
                </a>
                and are used here without authorization. All rights are reserved by Games Workshop Limited and the
                respective rights holders.
            </p>

            <p>
                The Animus is an unofficial community project. It is not affiliated with, sponsored by, or endorsed
                by Games Workshop Limited or The Poorhammer Podcast.
            </p>
        </div>
    `,
})
export class LicencesRightsContent {}
